import { useEffect, useState } from "react"

import { useSchedule } from "@shared/contexts"

export default function useCriteo() {
  const { schedule } = useSchedule()
  const [isLoaded, setIsLoaded] = useState(false)

  const isAll = schedule?.paymentInformation === "ALL"

  useEffect(() => {
    if (!isAll) return

    const script = document.createElement("script")

    script.type = "text/javascript"
    script.src = "//dynamic.criteo.com/js/ld/ld.js?a=99393"
    script.async = true
    script.onload = () => {
      setIsLoaded(true)
    }

    document.body.appendChild(script)
  }, [isAll])

  useEffect(() => {
    if (!isLoaded) return

    window.criteo_q = window.criteo_q || []
    var deviceType = /iPad/.test(navigator.userAgent)
      ? "t"
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
          navigator.userAgent,
        )
      ? "m"
      : "d"
    window.criteo_q.push(
      { event: "setAccount", account: 99393 },
      { event: "setEmail", email: "79054025255fb1a26e4bc422aef54eb4" },
      { event: "setZipcode", zipcode: "12345" },
      { event: "setSiteType", type: deviceType },
      {
        event: "trackTransaction",
        id: Math.floor(Math.random() * 99999999999),
        item: [{ id: "1", price: 1, quantity: 1 }],
      },
    )
  }, [isLoaded])
}
